import React, { useEffect, useState, useRef } from "react";
import { Select } from "antd";
import { list } from "../controllers/V1/users/usersController";

const SelectUsers = ({user_type = '', setAddEditData, defaultSelect = {} }) => {

const [OPTIONS, setOptions] = useState([defaultSelect] || []);
const [optionsLoading, setOptionsLoading] = useState(false);
const debounceTimeout = useRef(null);

const [ALLUSERSLIST, setAllUsersList] = useState([]);
const [selectedUser, setSelectedUser] = useState([]);

const getUsersData = async (searchText='') =>{
    try {
      const option = {
        condition : {
            ...(user_type?{users_type : user_type}:null),
            ...(isNaN(searchText) === true?{
              $or : [
                { users_name : { $regex: searchText, $options: "i" } },
                { last_name : { $regex: searchText, $options: "i" } },
              ]
            }:{ 
              $or : [
                {users_mobile : parseInt(searchText)},
                {pos_number : parseInt(searchText)},
              ]
            }) 
          // ...(search_by === ''?{ $text : { $search: searchString } }:null),
        },
        select : { users_type : true, users_name : true, last_name : true, users_mobile : true, users_email : true, store_name : true, area : true, bind_person_name : true, bind_person_mobile : true, commission_percentage : true, users_id : true, pos_serial_id : true, pos_number : true },
        sort : {_id : -1},
        limit : 0
      }
      const res = await list(option);
      if(res.status === true){
        setAllUsersList(res?.result || []);
      }
      setOptionsLoading(false);
    } catch (error) {
      
    }
  }

const handleUserChange = (value) =>{
    try {
        const userData = JSON.parse(value);
        setAddEditData((pre)=>({
            ...pre,
            bind_person_id : userData._id,
            bind_person_name : userData.users_name,
            bind_person_mobile : userData.users_mobile,
            userData : value
        }))
        console.log('userData   : ', userData);
    } catch (error) {
        console.log('error',error);
    }
}

const handleSearch = (value) => {
    if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
        if (value.trim() !== "" && value.length > 3) {
        getUsersData(value);
        }
    }, 500); 
};
useEffect(()=>{
    if(ALLUSERSLIST.length > 0){
      const transformedArray = ALLUSERSLIST.map(user => ({
        label: `${user.users_name} ${user.last_name} |  ${user.users_mobile}`,
        value: JSON.stringify(user) 
      }));
      setOptions(transformedArray);
      if(transformedArray.length === 1){
        setAddEditData((pre)=>({
            ...pre,
            bind_person_id : ALLUSERSLIST[0]._id,
            bind_person_name : ALLUSERSLIST[0].users_name,
            bind_person_mobile : ALLUSERSLIST[0].users_mobile
        }))
      }
    }
  },[ALLUSERSLIST]);
  return (
    <Select
        className="form-control"
        onSearch={handleSearch}
        onChange={handleUserChange}
        showSearch={true}
        defaultOpen={false}
        autoClearSearchValue={false}
        placeholder={OPTIONS?.[0]?.label || "Search to Select"}
        notFoundContent={null}
        loading={optionsLoading}
        defaultActiveFirstOption={true}
        options={OPTIONS}
        // value={OPTIONS.length === 1 ? OPTIONS[0].value : ''}
    />
  );
};

export default SelectUsers;
